<div class="form-horizontal">
  <div class="form-group">
    <input class="form-control" type="password" [(ngModel)]="passwords.OldPassword" (ngModelChange)="passwords.OldPassword = $event"
      (input)="onchangeModel()" name="oldPassword" placeholder="Введите старый пароль">
  </div>

  <div class="form-group">
    <input class="form-control" type="password" [(ngModel)]="passwords.NewPassword" (ngModelChange)="passwords.NewPassword = $event"
      (input)="onchangeModel()" name="newPassword" placeholder="Введите новый пароль">
  </div>

  <div class="form-group">
    <input class="form-control" type="password" [(ngModel)]="passwords.ConfirmPassword" (ngModelChange)="passwords.ConfirmPassword = $event"
      (input)="onchangeModel()" name="confirmPassword" placeholder="Повторите новый пароль">
  </div>

  <ng-container *ngIf="errorMessage">
    <div class="invalid-error">
      <p>{{errorMessage}}</p>
    </div>
  </ng-container>

  <ng-container *ngIf="successMessage">
    <div class="valid-success">
      <p>{{successMessage}}</p>
    </div>
  </ng-container>

  <div class="appartment-action">
    <ng-container *ngIf="!updateLoading">
      <button class="btn" [ngClass]="onChangeModel ? 'btn-primary' : 'btn-light'" [disabled]="!onChangeModel" (click)="!mioReadOnlyUserFlag ? savePasswords() : ''">Подтвердить</button>
      <button class="btn btn-light" (click)="closeModalWindow()">Отменить</button>
    </ng-container>
    <ng-container *ngIf="updateLoading">
      <div class="loading"></div>
    </ng-container>
  </div>
</div>
